import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
// DS3.1
import React from 'react';
import InputErrorMessage from '../../lego/InputErrorMessage';
import InputField from '../../lego/InputField';
import InputHint from '../../lego/InputHint';
import InputLabelSubText from '../../lego/InputLabelSubText';
import InputLabelText from '../../lego/InputLabelText';
import InputSuccessMessage from '../../lego/InputSuccessMessage';
import LimitedTextInputField from '../../lego/LimitedTextInputField';
import FormElement from '../../layouts/FormElement';
/**
 * A single line input field with a label and some details.
 */ const TextInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { id , label , isLabelHidden , subLabel , isRequired , details , validationResult , noBottomSpacing , maxLengthHidden , wrapperClassName  } = _param, rest = _object_without_properties(_param, [
        "id",
        "label",
        "isLabelHidden",
        "subLabel",
        "isRequired",
        "details",
        "validationResult",
        "noBottomSpacing",
        "maxLengthHidden",
        "wrapperClassName"
    ]);
    let wrappedDetails = null;
    const errorMessageId = `${id}-error`;
    const hintId = `${id}-hint`;
    switch(validationResult){
        case 'success':
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputSuccessMessage, null, details);
            break;
        case 'error':
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputErrorMessage, {
                id: errorMessageId
            }, details);
            break;
        default:
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputHint, {
                id: hintId
            }, details);
    }
    const commonInputProps = {
        id,
        isRequired,
        validationResult,
        'aria-errormessage': validationResult === 'error' ? errorMessageId : undefined,
        'aria-describedby': validationResult === undefined && details ? hintId : undefined,
        ref
    };
    return /*#__PURE__*/ React.createElement(FormElement, {
        inputId: id,
        label: /*#__PURE__*/ React.createElement(InputLabelText, {
            isRequired: isRequired
        }, label),
        isLabelHidden: isLabelHidden,
        subLabel: subLabel && /*#__PURE__*/ React.createElement(InputLabelSubText, null, subLabel),
        details: wrappedDetails,
        noBottomSpacing: noBottomSpacing,
        className: wrapperClassName
    }, rest.maxLength === undefined || maxLengthHidden ? /*#__PURE__*/ React.createElement(InputField, _extends({}, commonInputProps, rest)) : /*#__PURE__*/ React.createElement(LimitedTextInputField, _extends({
        maxLength: rest.maxLength
    }, commonInputProps, rest)));
});
TextInput.displayName = 'TextInput';
export default TextInput;
